import { SETTINGS } from './types';
import store from '../store';

export const loadSettings = config => {
    store.dispatch({
        type: SETTINGS.LOAD,
        data: config
    });
};

export const resetSettings = () => {
    store.dispatch({
        type: SETTINGS.RESET
    });
};
